import React from 'react';
import { Check, Utensils } from 'lucide-react';

export default function NutritionSection({ lang }) {
  const t = {
    sectionTag: lang === 'bg' ? 'ХРАНЕНЕ' : 'NUTRITION',
    headline: lang === 'bg' ? 'ХРАНЕНЕ ЗА СПОРТИСТИ' : 'ATHLETE NUTRITION',
    sub: lang === 'bg' ? 'Яж за представяне. Зареди за победа.' : 'Eat for performance. Fuel for victory.',
    items: lang === 'bg'
      ? [
          'Протоколи за зареждане преди и след тренировка',
          'Хидратационни планове за оптимално представяне',
          'Бързи рецепти с висока хранителна стойност за натоварен график',
        ]
      : [
          'Pre and post-workout fuelling protocols',
          'Hydration plans for optimal performance',
          'Quick high-nutrition recipes for a busy schedule',
        ],
    cta: lang === 'bg' ? 'ЗАПОЧНИ СЕГА' : 'START NOW',
  };

  return (
    <section className="relative bg-[#1e293b] py-20 md:py-28 overflow-hidden">
      {/* Top angled */}
      <div
        className="absolute top-0 left-0 right-0 h-20 bg-[#0f172a]"
        style={{ clipPath: 'polygon(0 0, 100% 0, 0 100%)' }}
      />

      {/* Decorative orange glow right */}
      <div className="absolute -right-40 top-1/2 -translate-y-1/2 w-96 h-96 rounded-full bg-amber-400/10 blur-3xl pointer-events-none" />

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-2 gap-12 md:gap-20 items-center">
          {/* Image */}
          <div className="relative order-2 md:order-1">
            <div className="relative rounded-3xl overflow-hidden shadow-2xl shadow-black/50">
              <img
                src="https://images.unsplash.com/photo-1547592180-85f173990554?w=800&q=80"
                alt="Healthy nutrition"
                className="w-full h-64 md:h-96 object-cover"
                loading="lazy"
              />
              {/* Overlay gradient */}
              <div className="absolute inset-0 bg-gradient-to-t from-[#1e293b]/80 via-transparent to-transparent" />
            </div>

            {/* Floating badge */}
            <div className="absolute -bottom-5 -right-3 md:-right-8 bg-gradient-to-br from-orange-500 to-amber-400 rounded-2xl px-5 py-3 shadow-2xl shadow-orange-500/40">
              <div className="text-white font-black text-2xl md:text-3xl">100%</div>
              <div className="text-white/90 text-xs font-bold uppercase tracking-wider">
                {lang === 'bg' ? 'Представяне' : 'Performance'}
              </div>
            </div>

            {/* Decorative lines */}
            <div className="absolute -top-6 -left-6 w-24 h-24 rounded-full border-2 border-orange-500/30 pointer-events-none" />
          </div>

          {/* Content */}
          <div className="order-1 md:order-2">
            <div className="inline-flex items-center gap-2 mb-4">
              <div className="w-8 h-8 rounded-lg bg-orange-500/20 flex items-center justify-center">
                <Utensils className="w-4 h-4 text-orange-400" />
              </div>
              <span className="text-orange-400 font-bold text-xs tracking-[0.3em] uppercase">
                {t.sectionTag}
              </span>
            </div>

            <h2 className="font-black uppercase text-3xl sm:text-4xl md:text-5xl leading-tight mb-4 text-white">
              {t.headline}
            </h2>

            <p className="text-slate-400 text-base md:text-lg mb-8 font-medium">
              {t.sub}
            </p>

            <ul className="space-y-4">
              {t.items.map((item, i) => (
                <li key={i} className="flex items-start gap-4">
                  <div className="flex-shrink-0 w-8 h-8 rounded-full bg-orange-500 flex items-center justify-center shadow-lg shadow-orange-500/30 mt-0.5">
                    <Check className="w-4 h-4 text-white" strokeWidth={3} />
                  </div>
                  <span className="text-slate-200 text-base md:text-lg leading-relaxed">
                    {item}
                  </span>
                </li>
              ))}
            </ul>

            <div className="mt-10">
              <a
                href="/s"
                className="inline-flex items-center gap-2 px-8 py-4 rounded-full font-black tracking-widest uppercase text-white transition-all duration-300 hover:scale-105 shadow-xl shadow-orange-500/30"
                style={{
                  background: 'linear-gradient(135deg, #f97316 0%, #f59e0b 100%)',
                }}
              >
                {t.cta}
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom angled */}
      <div
        className="absolute bottom-0 left-0 right-0 h-20 bg-[#0f172a]"
        style={{ clipPath: 'polygon(0 0, 100% 100%, 0 100%)' }}
      />
    </section>
  );
}
